import getConfig from 'next/config';
import { retryOnce } from '~/shared/utils/retry';
import { BetterStackPayload, CustomBetterStackEvent } from './types';
import { createPayload } from './utils';

export const sendToBetterStack = async (payload: BetterStackPayload) => {
    const { serverRuntimeConfig } = getConfig() || {};
    const url = serverRuntimeConfig?.NEXT_PUBLIC_BETTER_STACK_API_URL;
    const key = serverRuntimeConfig?.NEXT_PUBLIC_BETTER_STACK_API_KEY;

    if (!url) throw new Error('Better Stack API URL is not set.');

    const send = async () => {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${key}`,
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error(`Better Stack responded with ${response.status}.`);
    };

    // One retry, because most failures are short network or Better Stack errors.
    await retryOnce(send);
};

// Sends straight to Better Stack. Our log route only exists to hide our credentials client-side.
export const serverLog = async (event: CustomBetterStackEvent) => {
    const { serverRuntimeConfig } = getConfig() || {};
    const origin = serverRuntimeConfig?.NEXT_PUBLIC_URL || process.env.NEXT_PUBLIC_URL;

    try {
        await sendToBetterStack(createPayload(event, origin));
    } catch (error) {
        console.error(`Better Stack log "${event.event}" failed.`, error);
    }
};
